// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './views/mobile/css/iconfont.css'
import ElementUI from 'element-ui'
import VueFilter from 'vue-filter'
import Vue2Filters from 'vue2-filters'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router/router'
import store from './store/store'

import 'font-awesome/css/font-awesome.min.css'
import parseMenu from '@/utils/MenuUtil'
import VueI18n from 'vue-i18n'
import VueResource from 'vue-resource';
import FullCalendar from 'vue-full-calendar';

import "fullcalendar/dist/fullcalendar.min.css";

import Mint from 'mint-ui';
import VueCharts from 'vue-chartjs'
import VueQuillEditor from 'vue-quill-editor';

import 'mint-ui/lib/style.css'
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import VueLazyLoad from 'vue-lazyload'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
import vueDragInfinite from 'vue-drag-infinite'

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)



Vue.config.productionTip = false


Vue.use(ElementUI)
Vue.use(Vue2Filters)
Vue.use(VueFilter)
Vue.use(VueI18n)// 通过插件的形式挂载
Vue.use(VueResource);
Vue.use(VueQuillEditor);
Vue.use(FullCalendar);
Vue.use(Mint);
Vue.use(VueCharts);
Vue.use(vueDragInfinite)


Vue.use(VueLazyLoad,{
    error:'./static/error.png',
    loading:'./static/loading.png'
})


Vue.directive('dialogDrag', {
    bind(el, binding, vnode, oldVnode) {
        const dialogHeaderEl = el.querySelector('.el-dialog__header');
        const dragDom = el.querySelector('.el-dialog');
        dialogHeaderEl.style.cursor = 'move';

        // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
        const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);

        dialogHeaderEl.onmousedown = (e) => {
            // 鼠标按下，计算当前元素距离可视区的距离
            const disX = e.clientX - dialogHeaderEl.offsetLeft;
            const disY = e.clientY - dialogHeaderEl.offsetTop;

            // 获取到的值带px 正则匹配替换
            let styL, styT;

            // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
            if(sty.left.includes('%')) {
                styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
                styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
            }else {
                styL = +sty.left.replace(/\px/g, '');
                styT = +sty.top.replace(/\px/g, '');
            };

            document.onmousemove = function (e) {
                // 通过事件委托，计算移动的距离
                const l = e.clientX - disX;
                const t = e.clientY - disY;

                // 移动当前元素
                dragDom.style.left = `${l + styL}px`;
                dragDom.style.top = `${t + styT}px`;

                //将此时的位置传出去
                //binding.value({x:e.pageX,y:e.pageY})
            };

            document.onmouseup = function (e) {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }
    }
})

// v-dialogDragWidth: 弹窗宽度拖大 拖小
Vue.directive('dialogDragWidth', {
    bind(el, binding, vnode, oldVnode) {
        const dragDom = binding.value.$el.querySelector('.el-dialog');

        el.onmousedown = (e) => {

            // 鼠标按下，计算当前元素距离可视区的距离
            const disX = e.clientX - el.offsetLeft;

            document.onmousemove = function (e) {
                e.preventDefault(); // 移动时禁用默认事件

                // 通过事件委托，计算移动的距离
                const l = e.clientX - disX;
                dragDom.style.width = `${l}px`;
            };

            document.onmouseup = function (e) {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }
    }
})


const setHtmlFontSize = () => {
    const htmlDom = document.getElementsByTagName('html')[0];
    let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
    if (htmlWidth >= 750) {
        htmlWidth = 750;
    }
    if (htmlWidth <= 320) {
        htmlWidth = 320;
    }
    htmlDom.style.fontSize = `${htmlWidth / 7.5}px`;
};
window.onresize = setHtmlFontSize;
setHtmlFontSize();


//这里是防止用户手动刷新页面，整个app要重新加载,动态新增的路由，会消失，所以我们重新add一次
let staff = JSON.parse(window.sessionStorage.getItem('staff'))
if (staff){
//   console.log("Main refresh menus:",staff.menus);
  let routes = []
  parseMenu(routes,staff.menus)
  router.addRoutes(routes)
  router.options.routes.push(...routes);

  //更新VUX的staff，所有请求都是从vux.staff里取Token
  store.commit("updateStaff",staff);

  //判斷域名
    let hostName = window.document.location.hostname;
    if(hostName.indexOf("esupport")>=0 || hostName.indexOf('localhost')>=0 || hostName.indexOf('www.bigthertmr')>=0){
        store.commit("updateIsHkServer");
        store.commit("updateSystemCpy",1);
    }else if(hostName.indexOf("cpver3")>=0){

    }else if(hostName.indexOf("blueoak")>=0 || hostName.indexOf('bo.bigthertmr')>=0 || hostName.indexOf('system.blueoak.com.hk')>=0){
        store.commit("updateIsHkServer");
        store.commit("updateSystemCpy",2);
    }

}

//没登录就跳转到登录
router.beforeEach((to, from, next) => {
    let staff = JSON.parse(window.sessionStorage.getItem('staff'));
    var ismobile = localStorage.getItem('ismobile');
    if(ismobile == null){
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        ismobile = flag ? 1 : 0
    }

    // 电脑
    if (ismobile == 0) {
        if (!staff && to.path !== '/login'&& to.path !== '/loginEnter' && to.path!=='/renewalNotice' && to.path!=='/policyInfo' && to.path!=='/policyInfoFile'
            && to.path!=='/wechatMarketInfo' && to.path!=='/hr' && to.path!=='/overseaApply' && to.path!=='/commNote'&& to.path!=='/weixinSweepCode'
            && to.path!=='/questionnaire'&& to.path!=='/questionnaire2' ) {
            next({ path: '/login' })
        }else {
            next();
        }
    }
    // 手机
    if (ismobile == 1) {
        if(!staff && to.path!=='/mobile/mobileLogin' && to.path!=='/renewalNotice' && to.path!=='/policyInfo' && to.path!=='/policyInfoFile'
            && to.path!=='/wechatMarketInfo' && to.path!=='/hr' && to.path!=='/overseaApply' && to.path!=='/commNote'&& to.path!=='/weixinSweepCode'
            && to.path!=='/questionnaire'&& to.path!=='/questionnaire2' ){
                next({path: '/mobile/mobileLogin'})
        }else{
            next();
        }
    }

})

const i18n = new VueI18n({
    locale: 'zh-CN',    // 语言标识
    //this.$i18n.locale // 通过切换locale的值来实现语言切换
    messages: {
        'zh-CN': require('./common/lang/zh'),   // 中文语言包
        'en-US': require('./common/lang/en'),    // 英文语言包
        'zh-TW': require('./common/lang/tw')    // 繁体语言包
    }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,  // 不要忘记
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js